
export class TableIndex {
fields: string;
name: string;
unique: boolean;
}

